import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa";

const Nav = () => {
    return (
        <nav className="mainmenu-nav">
            <ul className="mainmenu">
                <li className="menu-item-has-children">
                    <NavLink 
                        to="/Home" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        Home
                    </NavLink>
                </li>
                <li className="menu-item-has-children">
                    <NavLink 
                        to="/about-us" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        About Us
                    </NavLink>
                </li>
                <li className="menu-item-has-children">
                    <NavLink 
                        to="/services" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        Services
                    </NavLink>
                </li>
                <li className="menu-item-has-children">
                    <NavLink 
                        to="/online-courses" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        Online Courses
                    </NavLink>
                </li>
                <li className="menu-item-has-children">
                    <NavLink 
                        to="/projects" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        Projects
                    </NavLink>
                </li>
                <li className="menu-item-has-children">
                    <NavLink 
                        to="/team" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        Team
                    </NavLink>
                </li>
                <li>
                    <NavLink 
                        to="/contact" 
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        Contact
                    </NavLink>
                </li>
            </ul>
        </nav>  
    );
};

export default Nav;
